'use client';
import React from 'react';
import {
  InputBase,
  InputLabel,
  FormControl,
  FormHelperText,
  InputBaseComponentProps,
} from '@mui/material';
import { RegisterOptions, UseFormRegister } from 'react-hook-form';

interface Props {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: RegisterOptions<any, string>;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  label?: string;
  value?: string;
  inputProps?: InputBaseComponentProps;
}

export const TextInput = React.forwardRef<unknown, Props>(
  ({ error, name, label, register, options, helperText, required, value, inputProps }, ref) => {
    return (
      <FormControl fullWidth variant="standard" error={error} required={required}>
        <InputLabel shrink htmlFor={name}>
          {label}
        </InputLabel>
        <InputBase id={name} {...register(name, options)} value={value} inputProps={inputProps} />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);
